import { computed } from 'vue';
import Widget from '../Widget/Widget';

export default class ButtonContentSwitcher extends Widget {
	private fitText = computed((): string => {
		return this.emptyText ? this.emptyText : 'Check your match';
	});
}
